import { CSSProperties } from 'react';
import { v4 as uuidv4 } from 'uuid';
import {
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Box,
  withStyles
} from '@material-ui/core';
import { Skeleton as MuiSkeleton } from '@material-ui/lab';
import { ColumnsType } from '@setvi/shared/types';

const Skeleton = withStyles({
  root: {
    width: '100%',
    height: 20
  }
})(MuiSkeleton);

interface STableLoaderProps {
  columns?: ColumnsType;
  rows?: number;
  height?: number;
  newDesign?: boolean;
}
interface CellStyle {
  width?: CSSProperties['width'];
  maxWidth?: CSSProperties['maxWidth'];
}

export const TableLoader = ({
  columns,
  rows = 8,
  height,
  newDesign
}: STableLoaderProps) => {
  const defaultStyles: CellStyle[] = [
    { width: '10%' },
    { width: '75%' },
    { width: '5%' }
  ];

  const styles = columns || defaultStyles;

  const getCell = (style: CellStyle, elem: string, index: number) => (
    <TableCell
      style={{
        ...style,
        ...(newDesign &&
          index === 0 && {
            borderTopLeftRadius: 12,
            borderBottomLeftRadius: 12
          }),
        ...(newDesign &&
          index === styles.length - 1 && {
            borderTopRightRadius: 12,
            borderBottomRightRadius: 12
          })
      }}
      key={elem}>
      {/**  The skeleton height will be row height - 32(top and bottom padding) */}
      <Skeleton variant="rect" height={height ? height - 32 : 20} />
    </TableCell>
  );

  return (
    <Box>
      {newDesign ? (
        <Box>
          {Array.from({ length: rows }, _ => uuidv4()).map(elem => (
            <Box key={elem} mb={2}>
              <TableContainer>
                <Table aria-label="Folders Table">
                  <TableBody>
                    <TableRow
                      style={{
                        background: '#fff'
                      }}>
                      {styles.map((i, index) =>
                        getCell(i, elem + uuidv4(), index)
                      )}
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          ))}
        </Box>
      ) : (
        <TableContainer>
          <Table aria-label="Folders Table">
            <TableBody>
              {Array.from({ length: rows }, _ => uuidv4()).map(elem => (
                <TableRow
                  key={elem}
                  style={{
                    background: 'transparent'
                  }}>
                  {styles.map((i, index) => getCell(i, elem + uuidv4(), index))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};
